import { Component } from '@angular/core';
import { MenuListRepository } from '../../../shared/repositories/menu-list.repository';
import { combineLatest, map, Observable, tap } from 'rxjs';
import { AsyncPipe, NgIf } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MenuNavComponent } from '../components/menu-nav/menu-nav.component';
import { BreakpointService } from '../../../shared/services/breakpoint.service';
import { MainPageAbstract } from '../../common/main-page.abstract';
import { FilterBarComponent } from '../components/filter-bar/filter-bar.component';
import { SessionRepository } from 'src/app/shared/repositories/session.repository';
import { TooltipDirective } from "src/app/shared/components/tooltip/tooltip.directive";

@Component({
  selector: 'app-fresh-main-page',
  templateUrl: './fresh-main-page.component.html',
  styleUrls: ['./fresh-main-page.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    AsyncPipe,
    RouterOutlet,
    MatProgressSpinnerModule,
    MenuNavComponent,
    MatIconModule,
    ReactiveFormsModule,
    FilterBarComponent,
    TooltipDirective
]
})
export class FreshMainPageComponent extends MainPageAbstract {
  constructor(
    protected override menuListRepository: MenuListRepository,
    protected override sessionRepository: SessionRepository,
    public breakPoint: BreakpointService,
  ) {
    super(menuListRepository, sessionRepository)
  }

  currentHasFilters: boolean = false;
  showTooltip = false;
  noFiltersMessage = $localize`:@@NoFiltersMessage:Filters are currently unavailable`;

  searchControl: FormControl<string> = new FormControl<string>('', { nonNullable: true });
  showFilterBar$: Observable<boolean> = this.sessionRepository.showFilterBar$;
  activeFilterCount$: Observable<number> = this.sessionRepository.activeFilterCount$;
  searchString$: Observable<string | null> = this.menuListRepository.searchString$
    .pipe(
      tap(searchString => {
        if (!searchString || searchString == '') {
          this.searchControl.reset()
        }
      })
    );

  hasAnyFilters$ = combineLatest([
    this.menuListRepository.labelList$,
    this.menuListRepository.allergenList$
  ]).pipe(
    map(([labels, allergens]) => {
      const hasLabels = !!labels && labels.length > 0;
      const hasAllergens = !!allergens && allergens.length > 0;
      return hasLabels || hasAllergens;
    }),
    tap(value => this.currentHasFilters = value)
  );

  onSearch(): void {
    this.menuListRepository.setSearchString(this.searchControl.getRawValue());
  }

  toggleShowFilterBar() {
    if (this.currentHasFilters){
      this.sessionRepository.toggleShowFilterBar();
    }
  }

  clearFilter() {
    this.sessionRepository.clearActiveFilter();
  }
}
